module.exports = __webpack_public_path__ + "img/activation.2f818e45.png";